import axios from "axios";
import { API } from "../App";

export const uploadPhoto = (file, sessionId, onProgress) => {
  const formData = new FormData();
  formData.append("file", file);
  formData.append("upload_session_id", sessionId);
  return axios
    .post(`${API}/photos/upload`, formData, {
      headers: { "Content-Type": "multipart/form-data" },
      onUploadProgress: (e) => {
        if (onProgress && e.total) onProgress(Math.round((e.loaded / e.total) * 100));
      },
    })
    .then((res) => res.data);
};

export const deletePhoto = (photoId, sessionId) =>
  axios.delete(`${API}/photos/${photoId}`, { params: { session_id: sessionId } });

export const updatePhotoCaption = (photoId, caption, sessionId) =>
  axios.put(`${API}/photos/${photoId}/caption`, { caption, session_id: sessionId });

export const getSessionPhotos = (sessionId) =>
  axios.get(`${API}/photos/session/${sessionId}`).then((res) => res.data);

export const getLeadPhotos = (leadId, token) =>
  axios
    .get(`${API}/photos/lead/${leadId}`, { headers: { Authorization: `Bearer ${token}` } })
    .then((res) => res.data);

export const photoFileUrl = (photoId, { sessionId, token } = {}) => {
  const params = new URLSearchParams();
  if (sessionId) params.set("session_id", sessionId);
  if (token) params.set("auth", token);
  return `${API}/photos/${photoId}/file?${params.toString()}`;
};
